/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import React from 'react'
import { List, ListRow, ListRowItem } from 'ui-library/dist/external/components'
import Money from '../../../unit/Money'

export default function Invoices(props) {
  if (!props.tab || props.tab !== 'invoices') {
    return null
  }

  if (!props.invoices || props.invoices.size === 0) {
    return null
  }

  return (
    <List>
      {props.invoices.map(invoice => (
        <ListRow key={invoice.id}>
          <ListRowItem
            width={'100%'}
            overline={`請求ID`}
            primaryText={
              <a href={`/invoice/${invoice.id}/detail`} target="_blank" rel="noopener noreferrer">
                {invoice.id}
              </a>
            }
          />
          <ListRowItem width={'50%'} overline={`種別`} primaryText={invoice.getInvoiceTypeLabel()} />
          <ListRowItem width={'50%'} overline={`状態`} primaryText={invoice.getStatusLabel()} />
          <ListRowItem width={'50%'} overline={`金額`} primaryItem={<Money>{invoice.total}</Money>} />
          <ListRowItem width={'50%'} overline={`通貨`} primaryText={invoice.currency} />
          <ListRowItem width={'100%'} overline={`顧客ID`} primaryText={invoice.customerid} />
          <ListRowItem width={'100%'} overline={`請求ID`} primaryText={invoice.invoiceid} />
          <ListRowItem width={'100%'} overline={`請求書URL`} primaryText={url(invoice.invoice_url)} />
          <ListRowItem width={'100%'} overline={`備考`} primaryText={<span style={{ whiteSpace: 'pre-wrap' }}>{invoice.note}</span>} />
        </ListRow>
      ))}
      {/* CSSで高さが取れず表示が途中で切れてしまうので余白を入れている */}
      <br />
      <br />
      <br />
      <br />
    </List>
  )
}

function url(value) {
  return (
    <a href={value} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  )
}
